import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomButton from '../../components/common/CustomButton';
import { API_BASE_URL } from '../../utils/constants';
import { validateMobileNumber } from '../../utils/utils';
import './LoginScreen.css';

const LoginScreen = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async () => {
    if (!mobileNumber) {
      toast.error('Please enter your mobile number.');
      return;
    }

    if (!validateMobileNumber(mobileNumber)) {
      toast.error('Invalid Mobile Number');
      return;
    }

    setLoading(true);
    
    try {
      const response = await fetch(`${API_BASE_URL}api/auth/doctor/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobile: mobileNumber
        }),
      });

      const result = await response.json();
      
      if (response.ok) {
        toast.success(result.message);
        navigate('/otp-verification', { 
          state: { 
            token: result.token, 
            mobile: mobileNumber 
          } 
        });
      } else {
        toast.error(result.errorInfo || 'Login failed');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
      console.error('Login Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={require('../../assets/images/logo.jpg')} alt="Expert for Professionals" className="login-logo" />
          <h1>Expert for Professionals</h1>
          <p>Enter your mobile number to receive an OTP for verification</p>
        </div>
        
        <div className="login-form">
          <div className="input-container">
            <div className="country-code">+91</div>
            <input
              type="tel"
              placeholder="Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              maxLength={10}
              className="mobile-input"
            />
          </div>
          
          <CustomButton
            title={loading ? 'Signing In...' : 'Sign In'}
            onPress={handleSignIn}
            disabled={loading}
            size="large"
          />
        </div>
        
        <div className="terms-container">
          <p>
            By continuing, you agree to our{' '}
            <button onClick={() => navigate('/terms-and-conditions')} className="link-text">Terms of Service</button>{' '}
            and{' '}
            <button onClick={() => navigate('/privacy-policy')} className="link-text">Privacy Policy</button>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;